import { useDispatch } from 'react-redux'
import { useState } from 'react'
import TableFilter from './tableFilter'
import ExportButton from '../../common/ExportButton'
import { appAllGetContribution } from '../../store/contribution'
import { contributionExportColumns } from '../../config/exportColumns/contributionExportColumns'
import { toCamelCase } from '../../utils/Function'

function Contribution() {
	const dispatch = useDispatch()

	const hubId = localStorage.getItem('hubId')
	const permissionOfHub = localStorage.getItem('permissionOfHub')

	const [exportFilters, setExportFilters] = useState({})

	return (
		<>
			<div className="content-wrapper">
				<div className="content-heading d-flex justify-content-between">
					<div>Contribution</div>

					<ExportButton
						fetchAction={params =>
							dispatch(
								appAllGetContribution({
									...params,
									...exportFilters,
									hub: hubId || permissionOfHub,
									limit: 10000,
									loading: false,
								}),
							)
						}
						columns={contributionExportColumns}
						fileName="Contributions"
						sheetName="Contribution List"
						buttonText="Export Contributions"
					/>
				</div>

				<TableFilter setExportFilters={setExportFilters} />
			</div>
		</>
	)
}

export default Contribution
